@let criteria = criteriaInput();
@if (criteria) {
  <fieldset class="conditionInputs">
    <legend>Cooling Conditions</legend>
    <div class="configurationDetailRow">
      <span>
        <label class="configurationInputLabel">Entering Dry Bulb:</label>
        <input type="number" class="configurationRatingTextInput" [class.invalidField]="isFieldInvalid('DryBulbTemperature')"
          [(ngModel)]="criteria.dryBulbTemperature" step="0.1">
        <label class="configurationRatingUnitLabel">{{ getTemperatureUnits() }}</label>
      </span>
    </div>
    <div class="configurationDetailRow">
      <span>
        <label class="configurationInputLabel">Entering Wet Bulb:</label>
        <input type="number" class="configurationRatingTextInput" [class.invalidField]="isFieldInvalid('WetBulbTemperature')"
          [(ngModel)]="criteria.wetBulbTemperature" step="0.1">
        <label class="configurationRatingUnitLabel">{{ getTemperatureUnits() }}</label>
      </span>
    </div>
    <div class="configurationDetailRow">
      <span>
        @if (!isRefrigerant()) {
          <label class="configurationInputLabel">Entering Fluid Temp:</label>
        }
        @if (isRefrigerant()) {
          <label class="configurationInputLabel">Sat. Suction Temp:</label>
        }
        <input type="number" class="configurationRatingTextInput" [class.invalidField]="isFieldInvalid('FluidTemperature')"
          [(ngModel)]="criteria.fluidTemperature" step="0.1">
        <label class="configurationRatingUnitLabel">{{ getTemperatureUnits() }}</label>
      </span>
    </div>
    <div class="configurationDetailRow">
      <span>
        <label class="configurationInputLabel">Fluid Type:</label>
        @if (!isRefrigerant()) {
          <span>
            <select class="configurationRatingSelectionInput"
              [(ngModel)]="criteria.fluidType">
              @for (allowable of fluidTypes(); track allowable) {
                <option class="configurationSelectionOption"
                  [value]="allowable.code">
                  {{ allowable.description }}
                </option>
              }
            </select>
          </span>
        }
        @if (isRefrigerant()) {
          <span>
            <label class="configurationRatingTextInput">R454B</label>
          </span>
        }
      </span>
    </div>
    @if (isGlycol(criteria.fluidType)) {
      <div class="configurationDetailRow">
        <span>
          <label class="configurationInputLabel">Glycol %:</label>
          <input type="number" class="configurationRatingTextInput" [class.invalidField]="isFieldInvalid('GlycolPercentage')"
            [(ngModel)]="criteria.glycolPercent" step="0.1">
        </span>
      </div>
    }
    <div class="configurationDetailRow">
      <span>
        <span class="configurationInputLabel">
          <select [(ngModel)]="deltaType" (change)="deltaChanged()">
            <option [value]="'tempChange'">Temp Change</option>
            <option [value]="'flowRate'">Flow Rate</option>
          </select>
        </span>
        <input type="number" [(ngModel)]="deltaValue" class="configurationRatingTextInput" (change)="deltaChanged()">
        <label class="configurationRatingUnitLabel">{{ getCoolingDeltaUnits() }}</label>
      </span>
    </div>
    <div class="configurationDetailRow">
      <span>
        <span class="configurationInputLabel">
          <select [(ngModel)]="criteria.targetType" (change)="targetTypeChanged()">
            @for (target of targetTypes; track target) {
              <option [value]="target.code">{{ target.description }}</option>
            }
          </select>
        </span>
        <input type="number" class="configurationRatingTextInput" [class.invalidField]="invalidCapacity()"
          [(ngModel)]="criteria.targetValue" step="0.1">
        <label class="configurationRatingUnitLabel">{{ getTargetTypeUnits() }}</label>
      </span>
    </div>
  </fieldset>
}
